import { PropageWindow } from "./abstract_classes/PropageWindow";

export class Propage {
  windows: PropageWindow[];

  constructor(trucs: PropageWindow[]) {
    this.windows = trucs;
  }

  get_window_names(): string[] {
    let names: string[];
    names = [];
    this.windows.forEach(window => {
      names.push(window.name);
    });
    return names;
  }

  get_windows_except(name: string): PropageWindow[] {
    let windows: PropageWindow[];
    windows = [];
    this.windows.forEach(window => {
      if (name != window.name) windows.push(window);
    });
    return windows;
  }
}
